import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/idp/')({
  beforeLoad() {
    throw redirect({
      to: '/idp/settings/sso'
    });
  }
});